import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { AppFloatingConfigurator } from '../../layout/component/app.floatingconfigurator';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ImageModule } from 'primeng/image';
import { User } from '../../core/interfaces';
import { BaseComponent } from '../../core/bases/base.component';
import { takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TokenResult } from '@app/core/services';

@Component({
  selector: 'app-auth',
  imports: [ImageModule, ButtonModule, FloatLabelModule, InputTextModule, PasswordModule, FormsModule, RouterModule, RippleModule, AppFloatingConfigurator, ReactiveFormsModule, IconFieldModule, InputIconModule],
  templateUrl: './auth.component.html',
})
export class AuthComponent extends BaseComponent {
  user: User = { email: '', password: '' };
  // user: User = { email: 'test@test.fr', password: 'testtest' };
  isLoggingIn: boolean = false;
  loginForm: FormGroup = new FormGroup({
    email: new FormControl(this.user.email, [Validators.required]),
    password: new FormControl(this.user.password, [Validators.required])
  });
  loginError?: string;

  onSubmit(): void {
    this.loginForm?.disable();
    this.user = this.loginForm.value;
    this.login();
  }

  login(): void {
    this.isLoggingIn = true;
    this.authService
      .login(this.user)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result: TokenResult) => {
          this.authService.loginHandler(this.user, result);
          this.isLoggingIn = false;
          this.router.navigate(['/products']);
        },
        error: (error: HttpErrorResponse) => {
          this.isLoggingIn = false;
          this.loginForm?.enable();
          if ([400, 401, 403, 422].includes(error.error.status)) {
            this.loginError = error.error.detail;
          }
        }
      });
  }
}
